




































































































import Vue from 'vue'
import { EventBus } from '../utils'
import { IMenuItem } from '../store/state'

interface CProps {
  msg: string
}
interface CMethods {
  hasChildren(page: IMenuItem): boolean
  showMenu(): void
  hideMenu(): void
  scrollToHash(): void
  toggleMenuItem(slug: string): void
  focusOnMenu(): void
  focusOnMenuButton(): void
  focusOnCloseButton(): void
  visibilityChangeHandler(): void
}

interface CComputed {
  routeName?: string | null
  menuVisible: boolean
  menu: []
  parentPage?: IMenuItem
  childrenPages: IMenuItem[]
  iconActiveItem: string
}

export default Vue.extend<{}, CMethods, CComputed, CProps>({
  name: 'MainMenu',
  props: {
    msg: String
  },
  mounted() {
    EventBus.$on('hide-menu', () => this.hideMenu())
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    menuVisible() {
      return this.$store.getters.showMenu
    },
    menu() {
      return this.$store.getters.menu
    },
    parentPage() {
      return this.menu.find((item: IMenuItem) => item.familyLevel === 'parent')
    },
    childrenPages() {
      return this.menu.filter((item: IMenuItem) => item.familyLevel === 'child')
    },
    iconActiveItem() {
      return this.$store.state.icons.arrowSelected
    }
  },
  methods: {
    hasChildren(page) {
      const children = this.$store.getters.routes.filter(
        (item: any) => item.parent === `/${page.slug}`
      )
      return children.length > 0
    },
    showMenu() {
      this.$store.dispatch({ type: 'showMenu' }).then(() => {
        document.addEventListener('focusin', this.visibilityChangeHandler)
        this.focusOnMenu()
      })
    },
    hideMenu() {
      this.$store.dispatch({ type: 'hideMenu' }).then(() => {
        this.focusOnMenuButton()
        document.removeEventListener('focusin', this.visibilityChangeHandler)
      })
    },
    scrollToHash() {
      EventBus.$emit('scroll-to-hash')
      this.hideMenu()
    },
    toggleMenuItem(slug) {
      this.$store.dispatch({ type: 'toggleMenuItem', payload: slug })
    },
    focusOnMenu() {
      const menuItemHTMLElement = (this.$refs.menuFirstItem as Vue)
        .$el as HTMLElement
      setTimeout(() => menuItemHTMLElement.focus(), 100)
    },
    focusOnMenuButton() {
      const menuButtonHTMLElement = this.$refs.menuButton as HTMLElement
      setTimeout(() => menuButtonHTMLElement.focus(), 30)
    },
    focusOnCloseButton() {
      const menuCloseHTMLElement = this.$refs.menuClose as HTMLElement
      setTimeout(() => menuCloseHTMLElement.focus(), 5)
    },
    visibilityChangeHandler() {
      const activeElement = document.activeElement as HTMLElement
      const menuWrapper = document.getElementById('menuWrapper') as HTMLElement
      if (!menuWrapper.contains(activeElement)) this.focusOnCloseButton()
    }
  }
})
